import { withInstall } from '@park-ui/utils'
import CigMap from './src/index.vue'

export const ElCigMap = withInstall(CigMap)

export default ElCigMap
